import React, { useCallback } from "react";
import { m } from "framer-motion";
// @mui
import { Avatar } from "@mui/material";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
// routes
import { paths } from "src/routes/paths";
import { useRouter } from "src/routes/hook";
// auth
import { useAuthContext } from "src/auth/hooks";
// hook
import usePopover from "src/hooks/use-popover";
// redux
import { dispatch } from "src/redux/store";
import { updateAccountTab } from "src/redux/slices/other";
// components
import { varHover } from "src/components/animate";
import { useSnackbar } from "src/components/snackbar";
import Popover from "src/components/template/popover";
// utils
import { ftName } from "src/utils/format-name";
//
import { IMAGE_BASE } from "src/config-global";

// ----------------------------------------------------------------------

const OPTIONS = [ {
    label: "Profile",
    linkTo: paths.dashboard.settings.profile.root
},
// {
//     label: "Transaction History",
//     linkTo: paths.dashboard.settings.transaction_history.root
// }
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
    const router = useRouter();

    const { user, logout, kicked } = useAuthContext();

    const { enqueueSnackbar } = useSnackbar();

    const popover = usePopover();

    const handleLogout = useCallback(() => logout().then(() => popover.onClose()).catch((e) => {
        const { code, msg } = e || {};

        if (code === "auth.jwt.invalid") {
            kicked();
        } else {
            enqueueSnackbar(msg, { variant: "error" });
            //
            console.error(e);
        }
    }), []);

    const handleClickItem = useCallback((label, path) => {
        dispatch(updateAccountTab(`${ label.toLowerCase() }`));
        //
        popover.onClose();
        //
        router.push(`${ path }`);
    }, []);

    // ----------------------------------

    return (
        <>
            <IconButton
                component={ m.button }
                whileTap="tap"
                whileHover="hover"
                variants={ varHover(1.05) }
                onClick={ popover.onOpen }
                sx={ {
                    width: 36,
                    height: 36,
                    marginX: "6px",
                    background: (theme) => alpha(theme.palette.grey[ 500 ], 0.08)
                } }
            >
                <Avatar src={ `${ IMAGE_BASE }/assets/icon/system/ic_default_user.svg` } alt="avatar" sx={ { width: 36, height: 36 } } />
            </IconButton>

            { popover.open && (
                <Popover open={ popover.open } onClose={ popover.onClose } sx={ { width: "240px", marginTop: "12px", marginLeft: "8px", p: 0 } }>
                    <Box sx={ { p: "20px", pb: "10px" } }>
                        <Stack direction="row" alignItems="start" justifyContent="space-between" spacing="12px">
                            <Typography variant="body2" color="text.primary" noWrap>
                                { ftName(user?.first_name, user?.last_name) || "-" }
                            </Typography>
                        </Stack>

                        <Typography variant="body1" color="text.secondary" noWrap>
                            { user?.email ?? "-" }
                        </Typography>
                    </Box>

                    <Divider sx={ { borderStyle: "dashed" } } />

                    <Stack sx={ { py: "6px", px: "10px" } }>
                        { OPTIONS.map((option) => (
                            <MenuItem key={ option.label } sx={ { py: "6px", px: "10px", color: "text.secondary" } } onClick={ () => handleClickItem(option.label, option.linkTo) }>
                                { option.label }
                            </MenuItem>
                        )) }
                    </Stack>

                    <Divider sx={ { borderStyle: "dashed" } } />

                    <Stack sx={ { py: "6px", px: "10px" } }>
                        <MenuItem
                            onClick={ handleLogout }
                            sx={ { py: "6px", px: "10px", fontSize: "14px", fontWeight: 400, color: "text.secondary" } }
                        >
                            Logout
                        </MenuItem>
                    </Stack>
                </Popover>
            ) }
        </>
    );
}
